import { render, staticRenderFns } from "./EmailMessagePrivateNote.vue?vue&type=template&id=bf328764&scoped=true&"
import script from "./EmailMessagePrivateNote.vue?vue&type=script&lang=js&"
export * from "./EmailMessagePrivateNote.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessagePrivateNote.vue?vue&type=style&index=0&id=bf328764&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf328764",
  null
  
)

export default component.exports